import { Module } from "vuex";
import { actions, STANDARD_OFFER_ACTIONS } from "./actions";
import { mutations, STANDARD_OFFER_MUTATIONS } from "./mutations";
import { DeliveryMethod, IStandardOfferState } from "./types";
import { IRootState } from "@/store/types";
import { cloneDeep } from "@/helpers/object";

export const state: IStandardOfferState = {
  isLoading: false,
  offersList: [],
  offer: {
    id: 0,
    minimumAmount: 0,
    maximumAmount: 0,
    name: "",
    applicationType: "",
    customerType: "",
    classOfBuyer: "",
    pricingProfile: "",
    rebateProfile: [""],
    collectionManager: "",
    salesRepresentative: "",
    validFromDate: null,
    validToDate: null,
    discounts: null,
    deliveryMethod: "StandardPost"
  },
  dataTable: {
    pagination: {
      sortBy: "createdDate"
    }
  }
};

export namespace STANDARD_OFFER {
  export const ACTIONS = STANDARD_OFFER_ACTIONS;
  export const MUTATIONS = STANDARD_OFFER_MUTATIONS;
  export const NAME_SPACE = "standardOffer";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const standardOffer: Module<IStandardOfferState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  actions,
  mutations
};
